module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Student-01_Thought-Bubble-dc4717e1bc7e33d3b06c491aee3258bc.png";